import ClearLayout from "@/auth/components/layout/clear-layout.tsx";
import { useState } from "react";
import toast from "react-hot-toast";
import ForgotPasswordForm, { ForgotPasswordInput } from "@/auth/components/forms/forgot-password-form.tsx";
import { Logo } from "@/shared/components/common/logo";
import { useTranslation } from "react-i18next";

const ForgotPassword = () => {
  const { t } = useTranslation("auth");

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onHandleSubmit = async (data: ForgotPasswordInput) => {
    setIsLoading(true);
    toast.error(t("forgotPassword.errors.incorrectPassword"));
    await new Promise((resolve) => setTimeout(resolve, 3000)); // 3 seconds sleep
    setIsLoading(false);
  }

  return (
    <ClearLayout>
      <div className={"flex flex-col w-full gap-8 justify-center items-center"}>
        <Logo alt={t("logoAlt")} className="h-16 w-auto" />
        <ForgotPasswordForm isLoading={isLoading} onSubmit={onHandleSubmit} />
      </div>
    </ClearLayout>
  );
};

export default ForgotPassword;
